import { create } from 'zustand';
import type { ExternalServicePaymentMethod, ExternalServiceType } from '../../shell/externalServiceRepo';

export type PosOverlayState = {
  variosVisible: boolean;
  variosName: string;
  variosAmount: string;
  /** Gap 5: si no es null, el modal está en modo edición de esta línea. */
  editingCustomLineId: string | null;
  setVariosVisible: (v: boolean) => void;
  setVariosName: (s: string) => void;
  setVariosAmount: (s: string) => void;
  /** Gap 5: abrir el modal en modo edición de una línea custom existente. */
  openVariosEditor: (lineId: string, name: string, amount: number) => void;
  closeVarios: () => void;

  recargaVisible: boolean;
  recargaType: ExternalServiceType;
  recargaAmount: string;
  recargaReference: string;
  recargaPaymentMethod: ExternalServicePaymentMethod;
  setRecargaVisible: (v: boolean) => void;
  setRecargaType: (t: ExternalServiceType) => void;
  setRecargaAmount: (s: string) => void;
  setRecargaReference: (s: string) => void;
  setRecargaPaymentMethod: (m: ExternalServicePaymentMethod) => void;
  closeRecarga: () => void;

  scannerVisible: boolean;
  setScannerVisible: (v: boolean) => void;

  /** Web / sin cámara: «Buscar código» abre carga manual del código. */
  manualBarcodeVisible: boolean;
  setManualBarcodeVisible: (v: boolean) => void;

  resetAll: () => void;
};

const initialState = () => ({
  variosVisible: false,
  variosName: '',
  variosAmount: '',
  editingCustomLineId: null as string | null,
  recargaVisible: false,
  recargaType: 'sube' as ExternalServiceType,
  recargaAmount: '',
  recargaReference: '',
  recargaPaymentMethod: 'cash' as ExternalServicePaymentMethod,
  scannerVisible: false,
  manualBarcodeVisible: false,
});

export const usePosOverlayStore = create<PosOverlayState>((set) => ({
  ...initialState(),

  // Al abrir un overlay cerramos el otro; al cerrar, no tocamos el campo del
  // otro overlay (nunca escribir `undefined`: zustand hace merge shallow y
  // asignar `undefined` sobreescribe el valor, lo que hace que el `Modal` de
  // RN caiga en su defaultProp `visible: true` y se abra solo).
  setVariosVisible: (v) =>
    set(v ? { variosVisible: v, scannerVisible: false, recargaVisible: false } : { variosVisible: v }),
  setVariosName: (s) => set({ variosName: s }),
  setVariosAmount: (s) => set({ variosAmount: s }),
  openVariosEditor: (lineId, name, amount) =>
    set({
      variosVisible: true,
      editingCustomLineId: lineId,
      variosName: name,
      variosAmount: String(amount),
      scannerVisible: false,
      recargaVisible: false,
    }),
  closeVarios: () => set({ variosVisible: false, variosName: '', variosAmount: '', editingCustomLineId: null }),

  setRecargaVisible: (v) =>
    set(v ? { recargaVisible: v, scannerVisible: false, variosVisible: false } : { recargaVisible: v }),
  setRecargaType: (t) => set({ recargaType: t }),
  setRecargaAmount: (s) => set({ recargaAmount: s }),
  setRecargaReference: (s) => set({ recargaReference: s }),
  setRecargaPaymentMethod: (m) => set({ recargaPaymentMethod: m }),
  closeRecarga: () =>
    set({
      recargaVisible: false,
      recargaAmount: '',
      recargaReference: '',
      recargaType: 'sube',
      recargaPaymentMethod: 'cash',
    }),

  setScannerVisible: (v) =>
    set(
      v
        ? { scannerVisible: v, variosVisible: false, recargaVisible: false, manualBarcodeVisible: false }
        : { scannerVisible: v },
    ),

  setManualBarcodeVisible: (v) =>
    set(
      v
        ? { manualBarcodeVisible: v, scannerVisible: false, variosVisible: false, recargaVisible: false }
        : { manualBarcodeVisible: v },
    ),

  resetAll: () => set({ ...initialState() }),
}));
